'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var Toggleable = require('../alloy-toggleable/Toggleable.js');
var stepper_module = require('./stepper.module.scss.js');

var Stepper = function (_a) {
    var children = _a.children, activeStep = _a.activeStep, setActiveStep = _a.setActiveStep, className = _a.className, _b = _a.disabled, disabled = _b === void 0 ? false : _b, props = tslib.__rest(_a, ["children", "activeStep", "setActiveStep", "className", "disabled"]);
    var setActiveChildren = react.useCallback(function (e) {
        if (setActiveStep && !disabled) {
            setActiveStep(e);
        }
    }, [setActiveStep]);
    return (jsxRuntime.jsx(Toggleable.default, tslib.__assign({ activeChildren: activeStep, setActiveChildren: setActiveChildren }, { children: jsxRuntime.jsx("nav", tslib.__assign({ className: "".concat(disabled ? stepper_module.default.stepperDisabled : stepper_module.default.stepper, " ").concat(className || '') }, props, { children: jsxRuntime.jsx("ol", tslib.__assign({ className: "d-flex p-0" }, { children: react.Children.map(children, function (child, index) {
                    return react.cloneElement(child, {
                        order: index,
                        stepperDisabled: disabled,
                    });
                }) })) })) })));
};
var Stepper$1 = react.memo(Stepper);

exports.default = Stepper$1;
//# sourceMappingURL=Stepper.js.map
